import UndoIcon from "@mui/icons-material/Undo";
import {
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  Collapse,
  Grid,
  IconButton,
  Paper,
  Step,
  StepLabel,
  Stepper,
  Typography,
} from "@mui/material";
import { useEffect, useState } from "react";
import { useLoaderData, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import BreadcrumbsComponent from "../../../../components/shared/breadcrumbs";

import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import { toJalaliFullDate } from "../../../../middleware/middleware";

const SolarentOperatorRequestInfoPage = () => {
  const data = useLoaderData("root");
  let navigate = useNavigate();
  const [steps, setSteps] = useState(
    data?.stepList.map((step) => ({
      ...step,
      collapse: step.stepInfoId && step.stepInfoId <= data.request.stepInfoId,
    }))
  );
  const [activeStep, setActiveStep] = useState(0);

  useEffect(() => {
    let index = data.stepList.findIndex(
      (x) => x.stepInfoId === data.request.stepInfoId
    );
    setActiveStep(index);
  }, [data]);

  const onNavigateToListPage = () => {
    navigate("/DG/SolarentOperator/Request");
  };

  const onClickCollapseButton = (collapse, index) => {
    if (index < activeStep) {
      let newSteps = steps;
      newSteps[index].collapse = !collapse;
      setSteps([...newSteps]);
    } else {
      toast.warning("فقط مراحل سپری شده، این امکان را دارند.");
    }
  };

  const onRenderRequestStatue = () => {
    switch (data?.request?.requestConfirm) {
      case "NotChecked":
        return "";
      case "Canceled":
        return (
          <Typography color={"secondary"}>
            (درخواست در این مرحله رد شده است)
          </Typography>
        );
      case "InProcess":
        return <Typography color={"primary"}>(مرحله کنونی)</Typography>;
      case "Completed":
        return "";
      default:
        return "";
    }
  };

  return (
    <Grid container spacing={3}>
      <Grid item xs={12} md={12}>
        <BreadcrumbsComponent />
      </Grid>
      <Grid item xs={12} md={12}>
        <Card>
          <CardHeader
            title={`بررسی درخواست ${data?.request?.projectTitle}`}
            subheader={"بررسی مراحل و تایید اسناد"}
            action={
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  width: "fit-content",
                }}
              >
                <Button
                  variant="outlined"
                  color="gray"
                  startIcon={<UndoIcon />}
                  onClick={onNavigateToListPage}
                >
                  بازگشت
                </Button>
              </Box>
            }
          />

          <CardContent>
            <Grid container spacing={3}>
              <Grid item xs={12} md={4} lg={3}>
                <Paper
                  elevation={3}
                  sx={{
                    p: 2,
                    height: "70vh",
                    overflow: "auto",
                    boxShadow: "0px 12px 21px 2px rgba(218, 230, 249, 0.4)",
                  }}
                >
                  <Box sx={{ maxWidth: 400 }}>
                    <Stepper activeStep={activeStep} orientation="vertical">
                      {steps.map((step, index) => (
                        <Step key={step.stepTitle}>
                          <StepLabel
                            optional={
                              index === steps.length - 1 ? (
                                <Typography variant="caption">
                                  آخرین مرحله
                                </Typography>
                              ) : null
                            }
                          >
                            {step.stepTitle}
                          </StepLabel>
                        </Step>
                      ))}
                    </Stepper>
                  </Box>
                </Paper>
              </Grid>

              <Grid container spacing={2} item xs={12} md={8} lg={9}>
                <Grid item xs={12} md={12}>
                  <Grid item xs={12} md={12} container className="custom-table">
                    <Grid item xs={12} md={12} className="row header">
                      <Typography
                        variant="h6"
                        fontWeight={"bold"}
                        color={"primary"}
                      >
                        {`اطلاعات درخواست(${data?.request?.stepTitle})`}
                      </Typography>
                    </Grid>
                    <Grid item xs={12} md={12} className="row" container>
                      <Grid item xs={12} md={6} container>
                        <Grid item xs={6} md={6} className="cell title">
                          نام متقاضی
                        </Grid>
                        <Grid item xs={6} md={6} className="cell value">
                          {data?.request?.projectOwnerFirstName}
                        </Grid>
                      </Grid>

                      <Grid item xs={12} md={6} container>
                        <Grid item xs={6} md={6} className="cell title">
                          نام خانوادگی متقاضی
                        </Grid>
                        <Grid item xs={6} md={6} className="cell value">
                          {data?.request?.projectOwnerLastName}
                        </Grid>
                      </Grid>
                    </Grid>

                    <Grid item xs={12} md={12} className="row" container>
                      <Grid item xs={12} md={6} container>
                        <Grid item xs={6} md={6} className="cell title">
                          عنوان پروژه
                        </Grid>
                        <Grid item xs={6} md={6} className="cell value">
                          {data?.request?.projectTitle}
                        </Grid>
                      </Grid>

                      <Grid item xs={12} md={6} container>
                        <Grid item xs={6} md={6} className="cell title">
                          شماره پیگیری
                        </Grid>
                        <Grid item xs={6} md={6} className="cell value">
                          {data?.request?.referenceID}
                        </Grid>
                      </Grid>
                    </Grid>

                    <Grid item xs={12} md={12} className="row" container>
                      <Grid item xs={12} md={6} container>
                        <Grid item xs={6} md={6} className="cell title">
                          شهرستان
                        </Grid>
                        <Grid item xs={6} md={6} className="cell value">
                          {data?.request?.cityName}
                        </Grid>
                      </Grid>

                    </Grid>

                    <Grid item xs={12} md={12} className="row" container>
                      <Grid item xs={12} md={6} container>
                        <Grid item xs={6} md={6} className="cell title">
                          وضعیت
                        </Grid>
                        <Grid item xs={6} md={6} className="cell value">
                          {data?.request?.requestConfirm}
                        </Grid>
                      </Grid>
                    </Grid>
                    <Grid item xs={12} md={12} className="row" container>
                      <Grid item xs={12} md={6} container>
                        <Grid item xs={6} md={6} className="cell title">
                          شماره پیگیری
                        </Grid>
                        <Grid item xs={6} md={6} className="cell value">
                          {data?.request?.referenceID}
                        </Grid>
                      </Grid>

                      <Grid item xs={12} md={6} container>
                        <Grid item xs={6} md={6} className="cell title">
                          تاریخ اعتبار
                        </Grid>
                        <Grid item xs={6} md={6} className="cell value">
                          {toJalaliFullDate(data?.request?.expireDate)}
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>

                {steps.map((step, index) => (
                  <Grid item xs={12} md={12} key={index}>
                    <Paper
                      elevation={3}
                      sx={{
                        p: 2,
                        boxShadow: "0px 12px 21px 2px rgba(218, 230, 249, 0.4)",
                      }}
                    >
                      <Box
                        sx={{ display: "flex", alignItems: "center", mb: 1 }}
                      >
                        <IconButton
                          onClick={() =>
                            onClickCollapseButton(step.collapse, index)
                          }
                        >
                          {step.collapse ? (
                            <RemoveCircleOutlineIcon />
                          ) : (
                            <AddCircleOutlineIcon />
                          )}
                        </IconButton>
                        <Typography>{step.stepTitle}</Typography>
                        {index === activeStep && onRenderRequestStatue()}
                      </Box>

                      <Collapse
                        in={step.collapse}
                        timeout="auto"
                        unmountOnExit
                        sx={{ width: "100%" }}
                      >
                        {index === activeStep && !step.adminComment ? (
                          <Typography color={"primary"}>
                            درخواست شما در حال بررسی است
                          </Typography>
                        ) : (
                          step.adminComment || "بدون نوشته"
                        )}
                      </Collapse>
                    </Paper>
                  </Grid>
                ))}
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  );
};

export default SolarentOperatorRequestInfoPage;
